/*eslint-disable*/
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// @mui/material components
import { makeStyles } from '@mui/styles';

// material ui icons
import Edit from '@mui/icons-material/Edit';
import UsersIcon from '@mui/icons-material/People';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/roleEditStyle.js';

// Redux
import { useLazyGetClientTenantsQuery } from 'api/client.api';
import { useLazyGetClientUsersQuery } from 'api/user.api';
import {
  selectClient,
  selectSessionStatus,
} from '../../features/session/sessionSlice';

const useStyles = makeStyles(styles);

export default function Users(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const sessionStatus = useSelector(selectSessionStatus);
  const defaultClient = useSelector(selectClient);
  const [client, setClient] = useState();
  const [triggerGetClientUsers, { data: users, isSuccess }] =
    useLazyGetClientUsersQuery();
  const [triggerGetClientTenants] = useLazyGetClientTenantsQuery();

  const capitalize = (text) => {
    return text?.charAt(0).toUpperCase() + text?.slice(1);
  };

  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if (sessionStatus === 'active' && !initialized) {
      setClient(defaultClient);
      setInitialized(true);
    }
  }, [sessionStatus, initialized]);

  useEffect(() => {
    if (sessionStatus === 'active' && initialized) {
      triggerGetClientUsers(client._id).unwrap();
      triggerGetClientTenants(client._id).unwrap();
    }
  }, [sessionStatus, initialized, client]);

  const handleEditUser = (index) => {
    props.history.push('/admin/user', { user: users[index], new: false });
  };

  const addUserHandler = () => {
    const newUser = {
      nt_administrator: false,
      status: 'invited',
      full_name: '',
      display_name: '',
      directory_id: '',
      client_id: client._id,
      email_address: '',
      phone_number: null,
      roles: [],
      default_environment: '',
      avatar: '',
      preferred_language: 'en-US',
    };
    props.history.push('/admin/user', { user: newUser, new: true });
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='rose'>
              <UsersIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Admin Users</h4>
            <Button
              color='rose'
              onClick={addUserHandler}
              className={classes.registerButton}
            >
              + Add Admin user
            </Button>
          </CardHeader>
          <CardBody>
            <GridContainer>
              {isSuccess && (
                <GridItem xs={12}>
                  <ReactTable
                    columns={[
                      {
                        Header: 'User Name',
                        accessor: 'name',
                        disableSortBy: true,
                        width: 200,
                      },
                      {
                        Header: 'Email Address',
                        accessor: 'email',
                        disableSortBy: true,
                        width: 200,
                      },
                      {
                        Header: 'Status',
                        accessor: 'status',
                        disableSortBy: true,
                        width: 50,
                      },
                      {
                        Header: 'Actions',
                        accessor: 'actions',
                        disableFilters: true,
                        disableSortBy: true,
                        width: 100,
                        style: {
                          marginBottom: 20,
                        },
                      },
                    ]}
                    data={users?.map((user, key) => ({
                      id: key,
                      name: user.full_name,
                      email: user.email_address,
                      status: capitalize(user.status),
                      actions: (
                        <div className='actions-left'>
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => handleEditUser(key)}
                            color='warning'
                            className='edit'
                          >
                            <Edit />
                          </Button>{' '}
                        </div>
                      ),
                    }))}
                    options={{
                      pageSize: users?.length,
                    }}
                  />
                </GridItem>
              )}
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
